









import { Component, Vue, Prop } from 'vue-property-decorator';
import PaymentForm from './components/paymentForm.vue';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';
import { paymentListInstance } from '@/model/PaymentListClass';


@Component({
  components: {
    PaymentForm,
  },
})
export default class CreatePayment extends Vue {
  private paymentListInstance = paymentListInstance;
  get paymentInfoForCreate() {
    return this.paymentListInstance.createPayment();
  }
  private createPayment(payment: IPayment.IRequest.IUpdatePaymentData): Promise<string> {
    return new Promise((reslove, reject) => {
      this.paymentListInstance.requestCreateItem(payment).then((res) => {
        reslove(res);
        this.goListPage();
      }).catch((err) => {
        reject(err);
      });
    });
  }
  private goListPage() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({
      name: 'Payment',
    });
  }
}
